/* eslint-disable no-case-declarations */
import { useEffect, useState } from 'react';
import { fetchAccommodation } from '../../../modules/api';
import { initialListingFilterObj } from '../../utils/constants';
import useFilters from '../../globalHooks/useFilters';

const useAccommodationListing = (id) => {
  const [accommodations, setAccommodations] = useState([]);
  const [rawAccommodations, setRawAccommodations] = useState([]);
  const [waiting, setWaiting] = useState(true);
  const [error, setError] = useState(null);
  const [destinations, setDestinations] = useState([]);
  const [activeFilters, setActiveFilters] = useState({
    ...initialListingFilterObj,
  });
  const [sort, setSort] = useState('popular');
  const [currentPage, setCurrentPage] = useState(0);

  const { filterDestination } = useFilters(activeFilters);

  useEffect(() => {
    if (id && rawAccommodations.length < 1) {
      (async () => {
        const feed = await getAccommodationFeed(id);
        setAccommodations(feed);
        setRawAccommodations(feed);
        setDestinations(getDestinations(feed));
      })();
    }
  }, [id]);

  const getDestinations = (feed) => {
    let returner = [
      {
        display: 'All',
        slug: 'All',
        id: 0,
      },
    ];

    feed.forEach(({ destinations }, index) => {
      if (destinations) {
        destinations.forEach((destination) => {
          if (!returner.find(({ slug }) => slug === destination.slug)) {
            returner = [...returner, destination];
          }
        });
      }
    });

    return returner;
  };

  useEffect(() => {
    let newAccommodation = filterDestination(rawAccommodations);

    newAccommodation = sortAccommodation(sort, [...newAccommodation]);
    setAccommodations(newAccommodation);
    setCurrentPage(0);
  }, [JSON.stringify(activeFilters), JSON.stringify(rawAccommodations), sort]);

  const getAccommodationFeed = async (id = '') => {
    try {
      setWaiting(true);

      return await fetchAccommodation(id);
    } catch (error) {
      console.error('Can not get accommodation feed', error);
      setError('An unexpected error has occurred');
    } finally {
      setWaiting(false);
    }
  };

  const sortAccommodation = (sort, accommodation) => {
    switch (sort) {
      case 'popular':
        return accommodation.sort(
          (a, b) => parseInt(a.popularity, 10) - parseInt(b.popularity, 10)
        );
      case 'new':
        return accommodation;
      case 'price_low':
        // use low price
        return accommodation;
      case 'price_high':
        // use high price
        return accommodation;
      case 'a-z':
        // alphabet ascending
        return accommodation.sort((a, b) =>
          a.title.display.charAt(0).toLowerCase() >
          b.title.display.charAt(0).toLowerCase()
            ? 1
            : -1
        );
      case 'z-a':
        // alphabet descending
        return accommodation.sort((a, b) =>
          b.title.display.charAt(0).toLowerCase() >
          a.title.display.charAt(0).toLowerCase()
            ? 1
            : -1
        );
      default:
        return accommodation;
    }
  };

  return {
    waiting,
    accommodations,
    rawAccommodations,
    error,
    setError,
    destinations,
    activeFilters,
    setActiveFilters,
    setSort,
    currentPage,
    setCurrentPage,
  };
};

export default useAccommodationListing;
